const ListBlock = ({items = []}) => {
    if (!items.length) return null;

    return (
        <ul className={`re-list`}>
            {items.map((item, index) => (
                <li key={index} className={`re-listItem`} dangerouslySetInnerHTML={{__html: item}}></li>
            ))}
        </ul>
    );
};

export default ListBlock;
